import { ROTATION_OF_LINE_ELEMENTS } from '../../services/service';
import { CS_RECESSED_CORNER_LEG, CS_STANDARD_CORNER_LEG } from './channels';
import { RESIZE_FACTOR, SIMPLE_ELEMENT_LENGTH } from './productsSlice';

/**
 * Calculates Price of all products
 * @param {number} productPriceEurState
 * @param {number} productPriceChfState
 * @param products
 * @return {[number, number]} [priceEURO, priceCHF]
 */
export function PUREcalculatePrices(productPriceEurState, productPriceChfState, products) {
    let productPriceEur = productPriceEurState ?? 0;
    let productPriceChf = productPriceChfState ?? 0;
    // eslint-disable-next-line array-callback-return
    products.map((item) => {
        if (item.product) {
            productPriceEur += item.product.price_eur;
            productPriceChf += item.product.price_chf;
        } else {
            productPriceEur += item.price_eur;
            productPriceChf += item.price_chf;
        }
    });
    return [productPriceEur, productPriceChf];
}

export function setPriceState(euro, chf, state) {
    state.productPriceEur = euro;
    state.productPriceChf = chf;
}

/**
 * Calculates count of operating devices
 * @param elements
 */
export function PUREcalculateOperatingDevices(elements) {
    let operatingDevices = 0;
    elements.forEach((el) => {
        if (el.type === 'master') operatingDevices++;
    });

    return operatingDevices;
}

/**
 * Calculates overall lumen and watt
 * @param state
 */
export function PUREcalculateOverallLumenAndWatt(userProducts, productCombinations, userSelectedDiffusor, userSelectedPower) {
    let products = userProducts;
    let combinations = JSON.parse(productCombinations);
    let currentDiffusor = userSelectedDiffusor.toUpperCase();
    let currentPower = userSelectedPower ? userSelectedPower.name : 'xHE';

    let lumen = 0;
    let watt = 0;

    products.forEach((el) => {
        let foundCombination = combinations.filter(
            (item) =>
                item.diffusor.toUpperCase() === currentDiffusor &&
                item.power.toUpperCase() === currentPower.toUpperCase() &&
                item.article_code === el.article_code
        )[0];
        if (foundCombination) {
            lumen += foundCombination.lm;
            watt += foundCombination.system_watt;
        } else {
            if (el != undefined) {
                if (currentDiffusor === 'ASYMMETRIC' || currentDiffusor === 'BOOST') {
                    lumen += el.lm;
                    watt += el.system_watt;
                } else {
                    console.log('Artikel ' + el.article_code + ' wurde nicht in der Kombinationsdatenbank gefunden!');
                }
            }
        }
    });

    return [lumen, watt.toFixed(2)];
}

/**
 * Calculates drawing coordinates and stores it in an array
 * @param state
 * @param elements
 * @param isRectangle
 */
export function PUREcalculateDrawingCoordinates(
    form, // userSelected
    rulesetName,
    selectedVisibleLayer,
    lightsLines, // userproducts
    isSimplifiedDrawing,
    drawingSimpleCoordinates,
    elements,
    isRectangle
) {
    let coordinates = [];
    let height = 10;
    let cornersMet = 0;

    let rotation = 0; //deg
    let x = 0;
    let y = 40;

    let border = '#000000';
    let masterColor = '#FFFFFF';
    let masterExpandableColor = 'url(#hatching)';
    let slaveExpandableColor = 'url(#hatching-with-bg)';
    let slaveColor = '#c1c1c1';
    let cornerColor = '#666666';

    if (rulesetName === 'Purelite Slim') {
        slaveExpandableColor = slaveColor;
    }

    let activeLayer = selectedVisibleLayer;
    if (activeLayer === 'electric') {
        masterColor = '#FFF303';
        masterExpandableColor = '#F63F3F';
        slaveExpandableColor = '#ABE444';
        slaveColor = '#FEECC0';
        cornerColor = '#449BE4';

        if (rulesetName === 'Flow') {
            masterColor = '#F63F3F';
            masterExpandableColor = '#F63F3F';
            slaveExpandableColor = '#ABE444';
            slaveColor = '#ABE444';
        } else if (rulesetName === 'Purelite') {
            masterColor = '#FFF303';
            masterExpandableColor = '#F63F3F';
            slaveColor = '#ABE444';
            slaveExpandableColor = '#ABE444';
            cornerColor = '#449BE4';
        }
    }

    const resizeFactor = RESIZE_FACTOR;

    if (form === 'L' || form === 'U') {
        rotation = 90;
    }

    if (isRectangle) {
        x = 200 / resizeFactor;
    }

    let lineNumber = 1;

    for (let i = 0; i < lightsLines.length; i++) {
        let type = lightsLines[i].type;
        let expandable = lightsLines[i].expandable === 0 || lightsLines[i].expandable === false ? false : true;
        let length = lightsLines[i].length;
        let color = cornerColor;

        let cornerRotation = ROTATION_OF_LINE_ELEMENTS[form][cornersMet];
        let rotationOfCorner = cornerRotation === 'L' ? -1 : 1;

        if (type === 'master' && expandable === true) {
            color = masterExpandableColor;
        } else if (type === 'master') {
            color = masterColor;
        } else if (type === 'slave' && expandable === true) {
            color = slaveExpandableColor;
        } else if (type === 'slave') {
            color = slaveColor;
        } else if (type === 'corner') {
            // Corners length was 200 until now to match its real product with a length of 200
            // But in the further calculations only 100 should be used
            length = length / 2;
        }

        // Simplify shape of each element for the installation map svg
        if (isSimplifiedDrawing) {
            length = SIMPLE_ELEMENT_LENGTH;
        }

        coordinates.push({
            actualLength: lightsLines[i],
            article: lightsLines[i].article_nr,
            border: border,
            color: color,
            x: x,
            y: y,
            w: length / resizeFactor,
            h: height,
            type: type,
            rotation: rotation,
            elementLength: length,
            cornerOrientation: cornerRotation,
            lineNumber: lineNumber,
        });

        if (rotation === 0) {
            x += length / resizeFactor;

            if (type === 'corner') {
                y += (length / resizeFactor) * rotationOfCorner;
                if (rotationOfCorner === -1) {
                    x -= height;
                    y += height;
                }
                cornersMet++;
            }
        } else if (rotation === 90) {
            y += length / resizeFactor;

            if (type === 'corner') {
                x -= (length / resizeFactor) * rotationOfCorner;
                if (rotationOfCorner === -1) {
                    y -= height;
                    x -= height;
                }
                cornersMet++;
            }
        } else if (rotation === 180) {
            x -= length / resizeFactor;
            if (type === 'corner') {
                y -= (length / resizeFactor) * rotationOfCorner;
                cornersMet++;
            }
        } else if (rotation === 270) {
            y -= length / resizeFactor;
            if (type === 'corner') {
                x += (length / resizeFactor) * rotationOfCorner;
                cornersMet++;
            }
        }

        if (type === 'corner') {
            if (ROTATION_OF_LINE_ELEMENTS[form][cornersMet - 1] === 'L') {
                rotation -= 90;
            } else {
                rotation += 90;
            }
            rotation = (rotation + 360) % 360;
            lineNumber++;
        }
    }

    // Special Case S must be moved down because of the draw order of the elements
    if (form === 'S' || form === 'U') {
        if (isSimplifiedDrawing) {
            let currentBiggest = 0;
            for (let i = 0; i < coordinates.length; i++) {
                if (Math.abs(coordinates[i].y) > currentBiggest) {
                    currentBiggest = Math.abs(coordinates[i].y);
                }
            }

            for (let i = 0; i < coordinates.length; i++) {
                coordinates[i].y += currentBiggest;
            }
        }
    }

    return coordinates;
}

/*
 * Calculates drawing coordinates and stores it in an array
 * !CAUTION!: Also sets the profileDrawingCoordinates state!
 * @param state
 * @param isRectangle
 */
export function PUREcalculateProfileDrawingCoordinates(
    form, // userSelected
    installation,
    rulesetName,
    selectedVisibleLayer,
    userProfiles, // userProfile
    profileData,
    isSimplifiedDrawing,
    drawingSimpleCoordinates,
    elements,
    isRectangle

    // state, isRectangle
) {
    let coordinates = [];
    let height = 10;
    let cornersMet = 0;

    let profiles = JSON.parse(userProfiles);

    let rotation = 0; //deg
    let x = 0;
    let y = 40;

    let border = '#000000';
    let profileWithHatching = 'url(#hatching)';
    let profileColor = '#ffffff';

    const resizeFactor = RESIZE_FACTOR;

    if (form === 'L' || form === 'U') {
        rotation = 90;
    }

    let profileLengths = PUREgetCorrectProfileLengths(profileData, form, installation);

    if (isRectangle) {
        x = 200 / resizeFactor;
    }

    let cornerLength = installation === 'recessed' ? CS_RECESSED_CORNER_LEG : CS_STANDARD_CORNER_LEG;
    if (isSimplifiedDrawing) {
        cornerLength = SIMPLE_ELEMENT_LENGTH;
    }
    let cornerOffset = cornerLength / resizeFactor;

    let colorIndex = 0;

    let cornersSetup = [];
    console.log(profileLengths);

    for (let i = 0; i < profileLengths.length; i++) {
        let type = 'profile';

        let cornerRotation = ROTATION_OF_LINE_ELEMENTS[form][cornersMet];

        //get all profiles for current line
        let profilesForLength = profiles.filter((item) => item.line === profileLengths[i].line);

        //mapping threw all profiles for line and adding them
        // eslint-disable-next-line array-callback-return,no-loop-func
        profilesForLength.map((item, index, arr) => {
            type = 'profile';
            let itemLength = item.product.length;
            let cut = item.cut;
            let color = colorIndex++ % 2 === 0 ? profileColor : profileWithHatching;
            let nextIsCorner = index === arr.length - 1; // Additional Offset to move corner out of the last element

            if (cut) {
                itemLength = cut;
            }
            // Simplify shape of each element for the installation map svg
            if (isSimplifiedDrawing) {
                itemLength = SIMPLE_ELEMENT_LENGTH;
                // Push Elements with coordinates
                coordinates.push({
                    actualLength: item.product.length,
                    article: item.product.article_nr,
                    border: border,
                    color: color,
                    x: x,
                    y: y,
                    w: itemLength / resizeFactor,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: itemLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
            } else {
                // Push Elements with coordinates
                coordinates.push({
                    actualLength: item.product.length,
                    border: border,
                    color: color,
                    x: x,
                    y: y,
                    w: itemLength / resizeFactor,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: itemLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
            }
            // Adds the offset to line each element after the last one; corner offset is only added if next element is a corner (end of current line)
            if (ROTATION_OF_LINE_ELEMENTS[form][cornersMet] === 'L') {
                if (rotation === 0) {
                    x += itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                } else if (rotation === 90) {
                    y += itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0); // DN-Left
                } else if (rotation === 180) {
                    x -= itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                } else if (rotation === 270) {
                    y -= itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                }
            } else {
                if (rotation === 0) {
                    x += itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                } else if (rotation === 90) {
                    y += itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0); // DN-RIGHT
                } else if (rotation === 180) {
                    x -= itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                } else if (rotation === 270) {
                    y -= itemLength / resizeFactor + (nextIsCorner ? cornerOffset : 0);
                }
            }
        });

        // Add a corner if there is more than one line and its not the last line or it is the O-Form (Corners everywhere)
        if ((i !== profileLengths.length - 1 && profileLengths.length > 1) || form === 'O') {
            type = 'corner';
            // CW: Ceiling & pendulum: Corners profile length is always 135mm for Channel S see article nr 2004.7098
            // CR: Recessed: Corners profile length is always 145mm for Channel S see article nr 2004.7100

            let cornerLength = installation === 'recessed' ? CS_RECESSED_CORNER_LEG : CS_STANDARD_CORNER_LEG;
            if (isSimplifiedDrawing) {
                cornerLength = SIMPLE_ELEMENT_LENGTH;
            }
            let color = 'red';
            let border = 'black'; // Corners seem to only react to border color settings
            if (rotation === 90) {
                coordinates.push({
                    article: installation === 'recessed' ? '2004.7100' : '2004.7098',
                    border: border,
                    color: color,
                    x: x,
                    y: y - cornerOffset,
                    w: cornerOffset,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: cornerLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
                // cornersSetup.push({article: installation === "recessed" ? "2004.7100" : "2004.7098", border: border, color: color, x: x, y: y - (cornerOffset), w: cornerOffset, h: height, type: type, rotation: rotation, elementLength: cornerLength, cornerOrientation: cornerRotation, line: profileLengths[i].line})
            } else if (rotation === 180) {
                coordinates.push({
                    article: installation === 'recessed' ? '2004.7100' : '2004.7098',
                    border: border,
                    color: color,
                    x: x + cornerOffset,
                    y: y,
                    w: cornerOffset,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: cornerLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
                // cornersSetup.push({article: installation === "recessed" ? "2004.7100" : "2004.7098", border: border, color: color, x: x + (cornerOffset), y: y, w: cornerOffset, h: height, type: type, rotation: rotation, elementLength: cornerLength, cornerOrientation: cornerRotation, line: profileLengths[i].line})
            } else if (rotation === 270) {
                coordinates.push({
                    article: installation === 'recessed' ? '2004.7100' : '2004.7098',
                    border: border,
                    color: color,
                    x: x,
                    y: y + cornerOffset,
                    w: cornerOffset,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: cornerLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
                // cornersSetup.push({article: installation === "recessed" ? "2004.7100" : "2004.7098", border: border, color: color, x: x, y: y + (cornerOffset), w: cornerOffset, h: height, type: type, rotation: rotation, elementLength: cornerLength, cornerOrientation: cornerRotation, line: profileLengths[i].line})
            } else if (rotation === 360 || rotation === 0) {
                coordinates.push({
                    article: installation === 'recessed' ? '2004.7100' : '2004.7098',
                    border: border,
                    color: color,
                    x: x - cornerOffset,
                    y: y,
                    w: cornerOffset,
                    h: height,
                    type: type,
                    rotation: rotation,
                    elementLength: cornerLength,
                    cornerOrientation: cornerRotation,
                    line: profileLengths[i].line,
                });
                // cornersSetup.push({article: installation === "recessed" ? "2004.7100" : "2004.7098", border: border, color: color, x: x - (cornerOffset), y: y, w: cornerOffset, h: height, type: type, rotation: rotation, elementLength: cornerLength, cornerOrientation: cornerRotation, line: profileLengths[i].line})
            }
        }

        // Offset line movement
        if (ROTATION_OF_LINE_ELEMENTS[form][cornersMet] === 'L') {
            if (rotation === 0) {
                y -= cornerOffset; // FIXED CORNER RT-L
            } else if (rotation === 90) {
                x += cornerOffset; // FIXED CORNER DN-L
            } else if (rotation === 180) {
                y += cornerOffset; // FIXED CORNER LT-R
            } else if (rotation === 270) {
                x -= cornerOffset; // FIXED CORNER UP-L
            }
        } else {
            if (rotation === 0) {
                y += cornerOffset; // FIXED CORNER RT-R
            } else if (rotation === 90) {
                x -= cornerOffset; // FIXED CORNER DN-R
            } else if (rotation === 180) {
                y -= cornerOffset; // FIXED CORNER LT-R
            } else if (rotation === 270) {
                x += cornerOffset; // FIXED CORNER UP-R
            }
        }

        if (ROTATION_OF_LINE_ELEMENTS[form][cornersMet] === 'L') {
            if (rotation === 0) {
                x -= height;
                y += height;
            } else if (rotation === 90) {
                x -= height;
                y -= height;
            } else if (rotation === 180) {
                x += height;
                y += height;
            } else if (rotation === 270) {
                x += height;
                y -= height;
            }

            rotation -= 90;
        } else {
            rotation += 90;
        }
        rotation = (rotation + 360) % 360;
        cornersMet++;
    }

    // Add corners now to make sure they are the first according to the drawing order
    // cornersSetup.forEach( corner => {
    // 	coordinates.push(corner);
    // })

    // Special Case S must be moved down because of the draw order of the elements
    if (form === 'S' || form === 'U') {
        if (isSimplifiedDrawing) {
            let currentBiggest = 0;
            for (let i = 0; i < coordinates.length; i++) {
                if (Math.abs(coordinates[i].y) > currentBiggest) {
                    currentBiggest = Math.abs(coordinates[i].y);
                }
            }

            for (let i = 0; i < coordinates.length; i++) {
                coordinates[i].y += currentBiggest;
            }
        }
    }

    return coordinates;
}

/**
 * Fixes calculated profile lengths by adding corner lengths and adding 2 lines to form O
 * @param {string} profiles is a json string (not the user)
 * @param {string} userSelectedForm
 * @param {string} userSelectedInstallation
 * @returns {any[]}
 */
export function PUREgetCorrectProfileLengths(profiles, userSelectedForm, userSelectedInstallation) {
    let profileLengths = JSON.parse(profiles);
    let form = userSelectedForm;
    let installation = userSelectedInstallation;
    //adding the last 2 lines to form O
    if (form === 'O') {
        profileLengths.push({ line: 'L3', profile: profileLengths[0].profile });
        profileLengths.push({ line: 'L4', profile: profileLengths[1].profile });
    }

    let cornerProfile = CS_STANDARD_CORNER_LEG;
    if (installation === 'recessed') {
        cornerProfile = CS_RECESSED_CORNER_LEG;
    }

    //adding cornerLengths to the profiles
    if (form === 'L') {
        profileLengths[0].profile += cornerProfile;
        profileLengths[1].profile += cornerProfile;
    } else if (form === 'S' || form === 'Z' || form === 'U') {
        profileLengths[0].profile += cornerProfile;
        profileLengths[1].profile += 2 * cornerProfile;
        profileLengths[2].profile += cornerProfile;
    } else if (form === 'O') {
        profileLengths[0].profile += 2 * cornerProfile;
        profileLengths[1].profile += 2 * cornerProfile;
        profileLengths[2].profile += 2 * cornerProfile;
        profileLengths[3].profile += 2 * cornerProfile;
    }

    return profileLengths;
}

/**
 * Maps the lighting elements array to real products
 * @param {[{type:any,length:any,expandable:true,color:string,power:any,product_line:string,orientation:any,article_code:string,}]|null} rulesetLightingSystemElements
 * @param {string} rulesetName
 * @param {string} userSelectedDiffusor
 * @param {{name:string}} userSelectedPower
 * @param {{kelvin:string}} userSelectedColor
 * @param {array} userProducts
 * @param {number} euro
 * @param {number} chf
 * @param {array} elements Array of every lighting product of the chosen family
 */
export function PUREmapElementsToProducts(
    rulesetLightingSystemElements,
    rulesetName,
    userSelectedDiffusor,
    userSelectedPower,
    userSelectedColor,
    userProducts,
    euro,
    chf,
    elements
) {
    let choosenProducts = [];

    let product_line = rulesetName;
    let current_diffusor = userSelectedDiffusor;

    let power = userSelectedPower ? userSelectedPower.name : 'xHE';
    let color = userSelectedColor ? userSelectedColor.kelvin : 4000;

    if (current_diffusor === 'boost') {
        product_line += ' Boost Office';
    }
    if (current_diffusor === 'asymmetric') {
        if (color === 'TW') {
            power = 'HPE';
        } else {
            power = 'HO';
        }
    }

    for (let i = 0; i < elements.length; i++) {
        let itemLength = elements[i].length;

        let product;
        if (elements[i].type === 'master') {
            if (color === 'TW') {
                // eslint-disable-next-line eqeqeq
                product = rulesetLightingSystemElements?.filter(
                    (item) =>
                        item.type === elements[i].type &&
                        item.length === itemLength &&
                        item.color == color &&
                        item.power === power &&
                        item.product_line === product_line
                );
            } else {
                // eslint-disable-next-line eqeqeq
                product = rulesetLightingSystemElements?.filter(
                    (item) =>
                        item.type === elements[i].type &&
                        item.length === itemLength &&
                        !!item.expandable === elements[i].expandable &&
                        item.color == color &&
                        item.power === power &&
                        item.product_line === product_line
                );
            }
        } else if (elements[i].type === 'slave') {
            // eslint-disable-next-line eqeqeq
            product = rulesetLightingSystemElements?.filter(
                (item) =>
                    item.type === elements[i].type &&
                    item.length === itemLength &&
                    !!item.expandable === elements[i].expandable &&
                    item.color == color &&
                    item.product_line == product_line
            );
        } else if (elements[i].type === 'corner') {
            itemLength *= 2; // Must double length of Channel S corner here because it is registered as 200 in the database
            // eslint-disable-next-line eqeqeq
            product = rulesetLightingSystemElements?.filter(
                (item) =>
                    item.type === elements[i].type &&
                    item.length === itemLength &&
                    !!item.expandable === elements[i].expandable &&
                    item.color == color &&
                    item.product_line == product_line &&
                    item.orientation === 'Orientation ' + elements[i].rotation
            );
        } else {
            console.log('kein gültiges Element');
        }

        if (product.length > 1) {
            //if more than 1 product, we have to filter if diffusor is asymmetric
            if (current_diffusor === 'asymmetric') {
                product = product.filter((item) => item.article_code.includes('AB') && !item.article_code.includes('E3h'));
            } else {
                product = product.filter((item) => !item.article_code.includes('AB') && !item.article_code.includes('E3h'));
            }
        }
        if (product.length === 0) {
            console.log(JSON.stringify(elements[i]));
        }
        choosenProducts.push(product[0]);
    }

    const [calculatedEuro, calculatedChf] = PUREcalculatePrices(euro, chf, choosenProducts);
    return [choosenProducts, calculatedEuro, calculatedChf];
}
